import * as React from 'react'
import RenderRouteList from './RenderRouteList'
import { RouteProps } from 'react-router'
import { useDidMount } from '../../common/hooks/common/useDidMount'
import { initDevUserInfo } from './initDevUserInfo'
import { isDev } from '../../common/business/isDev'

type PropsType = {
    routes: RouteProps[]
}

const AppRouter: React.FC<PropsType> = (props) => {
    useDidMount(() => {
        //初始化开发环境的默认 userId/token
        if (isDev()) {
            initDevUserInfo()
        }
    })
    return (
        /* 默认路由 */
        <RenderRouteList home={'/distribution'} routes={props.routes} />
    )
}

export default AppRouter
